const imgData_adultColoring_2021 = {
  berry_thief_coloring: {
    title: 'Berry Thief',
    imgs: {
      full: {
        src: require('./berry_thief_2022_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./berry_thief_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Highly detailed colouring page with a magpie, butterflies and floral elements.',
    digitalPrice: 4.37,
    /* prettier-ignore */
    printedPrice: 3.50,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/1209366539/',
    printedUrl: 'https://www.etsy.com/ie/listing/1171078013/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      'Highly detailed colouring page with a magpie, red admiral butterflies and floral elements, inspired by the native Irish forests.<br /><br />There are printed and digital versions available.<br /><br />Original artwork was created using black Indian ink on watercolour media paper.',
  },
  acer_palmatum_coloring: {
    title: 'Acer Palmatum - Japanese Cranes',
    imgs: {
      full: {
        src: require('./acer_palmatum_coloring_2022_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./acer_palmatum_coloring_2022_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2022',
    description:
      'A Japanese themed colouring page with cranes and the Japanese maple.',
    digitalPrice: 4.37,
    /* prettier-ignore */
    printedPrice: 5.40,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/1184420586/',
    printedUrl: 'https://www.etsy.com/ie/listing/1159317277/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      'This Japanese themed artwork offers beautiful details of the noble Japanese cranes and the iconic maple tree of Japanese gardens.<br /><br />There are printed and digital versions available.<br /><br />Original artwork was created using micron pens on mixed media paper.',
  },
  dragon_dance_iii: {
    title: 'Dragon Dance III',
    imgs: {
      full: {
        src: require('./dragon_dance_3_2022_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./dragon_dance_3_2022_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2022',
    description: 'A set of 3 dragon colouring pages.',
    digitalPrice: null,
    /* prettier-ignore */
    printedPrice: 9.00,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: '',
    printedUrl: 'https://www.etsy.com/ie/listing/1165809882/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      'In this third colouring adventure the dragons of Japan and China will take you to the wonders of the Far East! Challenge yourself with cherry blossoms, bring to life the iconic Japanese cranes, and try a variety of colours on the koi fish with these pages.<br /><br />This oriental edition of Dragon Dance is the most detailed to date, a real treat for those who love adult colouring!<br /><br />Original artwork was created using acrylic inks on mixed media paper.',
  },
  unicorns_colouring: {
    title: 'Unicorns',
    imgs: {
      full: {
        src: require('./unicorns_colouring_2021_web.jpg'),
        width: 1000,
        height: 707,
      },
      thumb: {
        src: require('./unicorns_colouring_2021_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2021',
    description: 'A set of 3 digital or printed unicorn colouring pages.',
    digitalPrice: 8.61,
    /* prettier-ignore */
    printedPrice: 9.00,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/1079458108/',
    printedUrl: 'https://www.etsy.com/ie/listing/1097502745/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      "Colour the mysterious unicorns of the world!<br /><br />Come and bring these magical creatures to life with colours! This colouring page set challenges you with 3 beautiful scenes with unicorns, all ready to get some magic with your help.<br /><br />There's a printed and a digital, print-at-home version available.<br /><br />Original artwork was created using acrylic inks on mixed media paper.",
  },
  dragon_dance_ii: {
    title: 'Dragon Dance II',
    imgs: {
      full: {
        src: require('./dragon_dance_ii_2021_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./dragon_dance_ii_2021_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2021',
    description: 'A set of 4 digital or printed dragon colouring pages.',
    digitalPrice: 11.44,
    /* prettier-ignore */
    printedPrice: 11.30,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/1033948904/',
    printedUrl: 'https://www.etsy.com/ie/listing/1035856004/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      "The adventure continues! Follow the path of the 4 elements in this new set of dragon coloring pages.<br /><br />Come along on a new journey with mighty dragons born from the four fundamental elements of the world: Air, Water, Earth and Fire!<br /><br />Each element summons its dragon and bird pair:<br /><br />1. Air - Great black-backed gulls<br />2. Water - Whooper swans<br />3. Earth - Ring-necked pheasants<br />4. Fire - Carrion crows<br /><br />There's a printed and a digital, print-at-home version available.<br /><br />Original artwork was created using acrylic inks on mixed media paper.",
  },
  rascals_coloring: {
    title: 'Rascals',
    imgs: {
      full: {
        src: require('./rascals_coloring_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./rascals_coloring_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description: 'A printable colouring page with starlings and brambles.',
    /* prettier-ignore */
    digitalPrice: 4.31,
    printedPrice: null,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/859944744/',
    printedUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      'This artwork was drawn at the end of summer when blackberries are ripe. And the cheeky little birds are always there to get them!',
  },
  farewell_colouring: {
    title: 'Farewell',
    imgs: {
      full: {
        src: require('./farewell_colouring_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./farewell_colouring_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description: 'An autumn-themed printable colouring page.',
    /* prettier-ignore */
    digitalPrice: 4.31,
    printedPrice: null,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/859944744/',
    printedUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      'When leaves are turning yellow and red the swallows are about to leave us once again. These lightning-fast little fellows are true markers of summers days, which we also have to say farewell to when they leave.<br /><br />This design was inspired by these times, when seasons are changing as well as our bird neighbours: winter visitors are arriving, and our summer friends are taking their leaves. The design was made to become a tshirt pattern, but I made it available as an adult colouring page as well.',
  },
  dragon_dance_i: {
    title: 'Dragon Dance I',
    imgs: {
      full: {
        src: require('./dragon_dance_i_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./dragon_dance_i_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description: 'A set of 3 digital or printed dragon colouring pages.',
    digitalPrice: 8.61,
    /* prettier-ignore */
    printedPrice: 9.00,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: 'https://www.etsy.com/ie/listing/838640143/',
    printedUrl: 'https://www.etsy.com/ie/listing/1049820219/',
    discount: 0,
    discountPrint: 0,
    merch: [
      {
        name: 'Bookmark Set',
        url: 'https://www.etsy.com/ie/listing/904511925/',
        price: 4.5,
      },
    ],
    type: 'adult_colouring',
    story:
      "A Draconic Colouring Adventure!<br /><br />Mighty fire-breathers, mystical Eastern spirits and swift water serpents come together for a dance in this set of colouring pages. Are they fighting? Or is there more to it? Give their dragon dance a mood by colouring the enchanted scenes!<br /><br />There's a printed and a digital, print-at-home version available.<br /><br />Original artwork was created using acrylic inks on mixed media paper.",
  },
  my_river_dance: {
    title: 'My River Dance',
    imgs: {
      full: {
        src: require('./my_river_dance_2020_web.jpg'),
        width: 703,
        height: 1000,
      },
      thumb: {
        src: require('./my_river_dance_2020_thumb.jpg'),
        width: 422,
        height: 600,
      },
    },
    year: '2020',
    description: 'A colouring poster for adults in 3 sizes.',
    digitalPrice: null,
    printedPrice: 21.95,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    digitalUrl: '',
    printedUrl: 'https://www.etsy.com/ie/listing/865606853/',
    discount: 0,
    discountPrint: 0,
    type: 'adult_colouring',
    story:
      "Why stop at a book-sized colouring page? Let's colour this giant poster featuring a heron, trouts, splashes of water and a willow tree, inspired by the Irish riversides. The poster is available in 3 sizes: 21×30cm (about A4 size), 30 x 40 cm (about A3 size), and 50 x 70 cm (about A2 size).<br /><br />Paper weight is 192 g/m², which is a decent paper weight for most medium. The poster is suitable for coloured pencils, markers, watercolour pencils, watercolour markers and even watercolour paints if applied with a moderate amount of water. The surface is a smooth matte finish.<br /><br />The artwork was inspired my walks along the beautiful Irish rivers: the Boyne, the Barrow, the Avonmore, and the Royal Canal. Grey herons are common residents along these waters and it's always a pleasure to see them hunting for fish. I wanted to capture this essence of the riverside in this picture, a connection to water that is very different from one to the sea.",
  },
};

export default imgData_adultColoring_2021;
